import downloadStudioUrl from '@modules/useStudio/constants/downloadStudioUrl';
import studioProtocolScheme from '@modules/useStudio/constants/studioProtocolScheme';
import { device, Platform } from '@rbx/core';
import { Locale } from '@rbx/intl';

const { getCurrentBrowser } = device;

type TStudioProtocolParams = {
  userId: string;
  locale: Locale;
  channel: string;
  assetId: string;
};

export enum EClientBinaryType {
  RCCService = 'RCCService',
  WindowsPlayer = 'WindowsPlayer',
  WindowsStudio = 'WindowsStudio',
  MacPlayer = 'MacPlayer',
  MacStudio = 'MacStudio',
  WindowsStudioCJV = 'WindowsStudioCJV',
  MacStudioCJV = 'MacStudioCJV',
  WindowsPlayerCJV = 'WindowsPlayerCJV',
  MacPlayerCJV = 'MacPlayerCJV',
}

export const getStudioBinaryType = (): EClientBinaryType => {
  const currentPlatform = device.getCurrentPlatform();

  if (process.env.buildTarget === 'global' && currentPlatform === Platform.macOS) {
    return EClientBinaryType.MacStudio;
  }

  if (process.env.buildTarget === 'luobu' && currentPlatform === Platform.macOS) {
    return EClientBinaryType.MacStudioCJV;
  }

  if (process.env.buildTarget === 'luobu' && currentPlatform === Platform.Windows) {
    return EClientBinaryType.WindowsPlayerCJV;
  }

  return EClientBinaryType.WindowsPlayer;
};
export const openStudioProtocol = (protocol: string): void => {
  const oldIframe = document.querySelector('[data-testid="studio-protocol-iframe"]');

  if (oldIframe) {
    oldIframe.remove();
  }

  const newIframe = document.createElement('iframe');
  newIframe.style.display = 'none';
  newIframe.src = protocol;
  newIframe.setAttribute('data-testid', 'studio-protocol-iframe');
  document.body.appendChild(newIframe);
};

export const getStudioProtocolURL = (params: TStudioProtocolParams): string => {
  const protocol = [
    `${studioProtocolScheme}:1`,
    'launchmode:asset',
    `launchtime:${new Date().getTime()}`,
    'avatar',
    `robloxLocale:${params.locale}`,
    `gameLocale:${params.locale}`,
    `channel:${params.channel}`,
    `browser:${getCurrentBrowser()}`,
    `userId:${params.userId}`,
    `assetid:${params.assetId}`,
    `distributorType:Global`,
  ];

  return protocol.join('+');
};

export const downloadStudio = () => {
  const iframe = document.createElement('iframe');
  iframe.title = 'studio-download';
  iframe.src = downloadStudioUrl;
  iframe.hidden = true;
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  setTimeout(() => {
    try {
      document.body.removeChild(iframe);
    } catch (_) {
      // Ignore
    }
  }, 10000);
};
